<template>
  <v-alert
    :color="alertStates.bgColor"
    class="px-5 py-4 ma-0 alert-root-wrapper"
    :class="alertState"
  >
    <div class="alert-root">
      <div
        class="alert-icon-container"
        :style="additionalCardStyle"
      >
        <icon
          class="alert-icon"
          :color="alertStates.iconColor"
          :name="alertStates.icon"
        />
      </div>

      <div
        class="ml-3"
        :style="additionalCardStyle"
      >
        <p
          class="alert-text-1 ma-0"
          :style="{ color: alertStates.textColor }"
        >
          <slot name="title" />
        </p>
        <p
          class="alert-text-2 ma-0"
          :style="{ color: alertStates.textColor }"
        >
          <slot name="text" />
        </p>
      </div>

      <div class="alert-button-container ml-4">
        <slot name="buttons" />
      </div>
    </div>
  </v-alert>
</template>

<script>
import { ALERT_STATES } from '@/constants/alert'
import Icon from '@/assets/icons/Icon.vue'

export default {
  name: 'AuthAlert',

  components: { Icon },

  props: {
    alertState: {
      type: String,
      default: ALERT_STATES.SUCCESS_ALERT,
      required: false
    }
  },

  computed: {
    alertStates () {
      if (this.alertState === ALERT_STATES.SUCCESS_ALERT) {
        return {
          bgColor: 'alert-success-background',
          icon: 'checkFilled24',
          iconColor: 'var(--v-alert-success-icon-base)',
          textColor: 'var(--v-alert-success-foreground-base)'
        }
      } else if (this.alertState === ALERT_STATES.WARNING_ALERT) {
        return {
          bgColor: 'alert-warning-background',
          icon: 'warningFilled24',
          iconColor: 'var(--v-alert-warning-icon-base)',
          textColor: 'var(--v-alert-warning-foreground-base)'
        }
      } else if (this.alertState === ALERT_STATES.ERROR_ALERT) {
        return {
          bgColor: 'alert-error-background',
          icon: 'warningFilled24',
          iconColor: 'var(--v-alert-error-icon-base)',
          textColor: 'var(--v-alert-error-foreground-base)'
        }
      }

      return null
    },

    additionalCardStyle () {
      if (!this.$slots.text && this.$slots.buttons) {
        return 'margin: auto'
      }

      return null
    }
  }
}
</script>

<style lang="scss">
.alert-root-wrapper {
  border-radius: 8px;
}

.alert-icon-container {
  line-height: 0;
}

.successAlert {
  outline: 1px solid var(--v-alert-success-border-base);
}

.warningAlert {
  outline: 1px solid var(--v-alert-warning-border-base);
}

.errorAlert {
  outline: 1px solid var(--v-alert-error-border-base);
}

.alert-root {
  display: flex;
}

.alert-icon {
  width: 20px;
  height: 20px;
}

.alert-text-1 {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
}

.alert-button-container {
  flex: 1;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
}

.alert-text-2 {
  font-family: Roboto, sans-serif;
  font-size: 14px;
}
</style>

